/**
 * The page's own loading poster (#boot in index.html): up before the game's
 * code arrives, shown again between days, and the place for the messages when
 * the game can't run at all.
 */
const part = (sel: string): HTMLElement | null => document.querySelector(`#boot ${sel}`);

export function bootLoading(note = 'drawing today’s circuit…'): void {
  const b = document.getElementById('boot');
  if (!b || b.classList.contains('problem')) return;
  b.classList.remove('gone');
  const n = part('.note');
  if (n) n.textContent = note;
}

export function bootDone(): void {
  const b = document.getElementById('boot');
  if (b && !b.classList.contains('problem')) b.classList.add('gone');
}

/** The game can't run here (no 3D), or it broke: say so on the poster, with a reload for a crash. */
/**
 * No 3D: on a computer it's most often switched off in the browser's settings (graphics acceleration), which
 * the player can turn back on; on a phone, another browser is the way.
 */
function no3dText(): string {
  const phone = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  return phone
    ? 'This browser isn’t drawing 3D graphics, which the game needs. Try an up-to-date Chrome or Safari.'
    : 'This browser isn’t drawing 3D graphics, which the game needs. In its settings, search for “acceleration”, turn graphics acceleration on and restart the browser.';
}

export function bootProblem(kind: 'no3d' | 'crash'): void {
  const b = document.getElementById('boot');
  if (!b) return;
  b.classList.remove('gone');
  b.classList.add('problem');
  const msg = part('.msg');
  const note = part('.note');
  const again = part('.again') as HTMLButtonElement | null;
  if (msg) {
    msg.hidden = false;
    msg.textContent = kind === 'no3d' ? no3dText() : 'Something went wrong.';
  }
  if (note) note.textContent = kind === 'no3d' ? 'sorry about that' : 'reload to race again';
  if (again) {
    again.hidden = kind === 'no3d';
    again.onclick = () => location.reload();
  }
}
